module.exports = __webpack_public_path__ + "static/media/ehealth_radi_record_banner_desktop.99d04add.jpg";